import {
    Checkbox,
    Container,
    FormControlLabel,
    Typography,
} from '@mui/material';
import { consentInfo } from '../helpers/consentInfo';

interface ConsentPageProps {
    hasUserConsent: boolean;
    setHasUserConsent: (hasUserConsent: boolean) => void;
    focusOnNext: () => void;
}

export const ConsentPage = ({
    hasUserConsent,
    setHasUserConsent,
    focusOnNext,
}: ConsentPageProps) => {
    return (
        <Container>
            <Typography
                variant="h4"
                sx={{ fontWeight: 'bold', marginBottom: 3 }}
            >
                How does your voice compare to a teacher?
            </Typography>
            <Typography variant="body1" sx={{ marginBottom: 3 }}>
                Researchers at Simon Fraser University are studying what exactly
                makes an engaging teaching voice.
                <b>
                    Before participating in this study please read the following
                    information.
                </b>
            </Typography>
            {consentInfo.map((info, index) => {
                return (
                    <Container key={index}>
                        <Typography
                            key={`title-${index}`}
                            variant="h5"
                            sx={{ fontWeight: 'bold', marginBottom: 1 }}
                        >
                            {info.title}
                        </Typography>
                        <Typography
                            variant="body1"
                            sx={{ marginBottom: 3 }}
                            key={`body-${index}`}
                        >
                            {info.body}
                        </Typography>
                    </Container>
                );
            })}

            <Container>
                <FormControlLabel
                    control={
                        <Checkbox
                            onChange={async (e) => {
                                await setHasUserConsent(e.target.checked);
                                if (focusOnNext) focusOnNext();
                            }}
                            checked={hasUserConsent}
                        />
                    }
                    label="I have read and accept the consent form"
                />

                {!hasUserConsent && (
                    <Typography
                        variant="body2"
                        sx={{
                            fontWeight: 'bold',
                            marginBottom: 1,
                            color: 'red',
                        }}
                    >
                        You will have to accept and read the consent form to
                        participate.
                    </Typography>
                )}
            </Container>
        </Container>
    );
};